export const ROOT = '/';

export const ACCOUNTS = '/accounts';
export const ACCOUNT_DETAIL = '/accounts/:accountId';
export const ACCOUNT_ALLOCATIONS = '/accounts/:accountId/allocations';
export const ACCOUNT_PLAN_DETAIL = '/accounts/:accountId/plans/:planId';
export const WORKSPACE_DETAIL = '/accounts/:accountId/workspaces/:workspaceId';

export const CONTRACTS = '/contracts';
export const CONTRACTS_ADD = '/contracts/add';
export const CONTRACTS_ALL = '/contracts/all';
export const CONTRACT_DETAIL = '/contracts/:contractId';
export const CONTRACT_LINEITEM_DETAIL =
  '/contracts/:contractId/products/:lineItemId';
export const CONTRACT_VALIDATE = '/contracts/:contractId/validate';

export const DASHBOARD = '/dashboard';

export const OPS = '/ops';

export const LABS = '/labs';

export const ORDERS = '/orders';
export const ORDER_DETAIL = '/orders/:orderId';

export const ORGS = '/organizations';
export const ORG_DETAIL = '/organizations/:orgId';
export const ORG_GENERAL = '/organizations/:orgId/general';
export const ORG_PLANS = '/organizations/:orgId/plans';
export const ORG_PLAN_TASKING = '/organizations/:orgId/plans/tasking';
export const ORG_PLAN_TASKING_DETAIL =
  '/organizations/:orgId/plans/tasking/:plNumber';
export const ORG_PLAN_DETAIL = '/organizations/:orgId/plans/:planId';
export const ORG_ENTITLEMENTS = '/organizations/:orgId/entitlements';
export const ORG_SUBORGS = '/organizations/:orgId/suborgs';
export const ORG_USERS = '/organizations/:orgId/users';

export const PLANS = '/plans';
export const PLAN_DETAIL = '/plans/:planId';
export const PLAN_CONTRACTS = '/plans/contract';
export const PLAN_CONTRACT_DETAIL = '/plans/contract/:contractId';
export const PLAN_CONTRACT_LINEITEM_DETAIL =
  '/plans/contract/:contractId/product/:lineItemId';
export const PLAN_TASKING = '/plans/tasking';
export const PLAN_TASKING_DETAIL = '/plans/tasking/:plNumber';

export const PRODUCT_DETAIL = '/products/:productAccessId';

export const PROVISION = '/provision';
export const PROVISION_ADD = '/provision/add';

export const SENTINEL_HUB_CALLBACK = '/sh-callback';
export const SENTINEL_HUB_REDIRECT = '/sh-redirect';

export const USERS = '/users';
export const USER_DETAIL = '/users/:userId';
export const USER_SETTINGS = '/user-settings';

export const MIGRATION_WIZARD = '/migration-wizard';
export const MIGRATION_EVAL_SETUP = '/migration-setup';

export const ARCHIVE_CONTROL = '/archive-control';

export const ADMIN_REPORTS = '/admin/reports';

export const SELF_SERVICE_ORDERS = '/orders/self-service';

const routes = {
  ROOT,
  CONTRACTS,
  CONTRACTS_ADD,
  CONTRACTS_ALL,
  CONTRACT_DETAIL,
  CONTRACT_LINEITEM_DETAIL,
  CONTRACT_VALIDATE,
  DASHBOARD,
  LABS,
  ORDERS,
  ORDER_DETAIL,
  ORGS,
  ORG_DETAIL,
  ORG_ENTITLEMENTS,
  ORG_GENERAL,
  ORG_PLANS,
  ORG_PLAN_TASKING,
  ORG_PLAN_TASKING_DETAIL,
  ORG_PLAN_DETAIL,
  ORG_SUBORGS,
  ORG_USERS,
  PLANS,
  PLAN_DETAIL,
  PLAN_CONTRACTS,
  PLAN_CONTRACT_DETAIL,
  PLAN_CONTRACT_LINEITEM_DETAIL,
  PLAN_TASKING,
  PLAN_TASKING_DETAIL,
  PROVISION,
  PROVISION_ADD,
  SENTINEL_HUB_CALLBACK,
  SENTINEL_HUB_REDIRECT,
  USERS,
  USER_DETAIL,
  USER_SETTINGS,
  MIGRATION_WIZARD,
  MIGRATION_EVAL_SETUP,
  ARCHIVE_CONTROL,
  ADMIN_REPORTS,
  SELF_SERVICE_ORDERS,
  ACCOUNT_ALLOCATIONS,
  ACCOUNT_PLAN_DETAIL,
  OPS,
};

export default routes;
